import { PubSub } from '@instinet-analytics/core-lib';
import { BarMouseOverState } from 'widgets/portfolioSummary/chart/BarMouseOver';
import { MouseEvent, MouseEventHandler, useCallback } from 'react';

export class BarMouseOver extends PubSub<BarMouseOverState> {}

export interface BubbleMouseOverState {
    orderIds: string[];
    y?: number;
}

export class BubbleMouseOver extends PubSub<BubbleMouseOverState> {}

export function useBubbleMouseOverHandler(
    bubbleMouseOver: BubbleMouseOver
): MouseEventHandler<HTMLDivElement> {
    return useCallback(
        (e: MouseEvent<HTMLDivElement>) => {
            const orderIds = getOrderIdsForBubblesUnderMouse(e);
            bubbleMouseOver.publish({ orderIds, y: e.nativeEvent.offsetY });
        },
        [bubbleMouseOver]
    );
}

export function getOrderIdsForBubblesUnderMouse(e: MouseEvent<HTMLDivElement>) {
    const el = document.elementsFromPoint(e.clientX, e.clientY);

    return el
        .filter((e) => e.tagName === 'path')
        .filter((e) => !!e.attributes.getNamedItem('bubble-order-id'))
        .map((e) => e.attributes.getNamedItem('bubble-order-id')!.value);
}
